import Iconmoon from '@deprecated-ui/common/Iconmoon';
import color from '@deprecated-ui/_style/color';
import React, { memo } from 'react';
import { ActionIconWrapper } from './styled';

interface SliderNavigationProps {
  onClick: () => void;
  type: 'next' | 'prev';
  visible: boolean;
}

function SliderNavigation({ type, visible, onClick }: SliderNavigationProps) {
  const position = type === 'next' ? 'right' : 'left';

  return (
    <ActionIconWrapper
      type="button"
      position={position}
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
      visible={visible}
    >
      <Iconmoon
        className={`icon-toolbar_${type}`}
        color={color.light}
        hoverColor={color.dimgray}
      />
    </ActionIconWrapper>
  );
}

export default memo(SliderNavigation);
